import type {Size} from "./types";

export const useGlobalStyles = () => {

    const roundedClasses = (rounded: Size) => {
        switch (rounded) {
            case "xs":
                return "rounded-sm"
            case "sm":
                return "rounded-md"
            case "md":
                return "rounded-lg"
            case "lg":
                return "rounded-2xl"
            case "xl":
                return "rounded-full"
            default:
                return "rounded-sm"
        }
    }

    const textSizes = (size: Size) => {
        switch (size) {
            case "xs":

                return "text-xs"
            case "sm":

                return "text-sm"
            case "md":

                return "text-md"
            case "lg":

                return "text-lg"
            case "xl":

                return "text-2xl"
            default:

                return "text-base"
        }
    }

    return {roundedClasses, textSizes}
}